














import { Prop, Component, Vue } from 'vue-property-decorator'
import { Branch } from '@/api/model/branch'
import ListTeamsActions from '@/views/Company/Settings/Teams/List/ListTeamsActions.vue'
import { User } from '@/api/model/user'

@Component({
    components: {ListTeamsActions},
})
export default class ListTeams extends Vue {
    @Prop({ required: true }) readonly teams!: Branch[]

    countUsers(team: Branch): number {
        return this.$currentCompany.users
            .filter((user: User) => user.branches
                .filter(branch => branch.id === team.id).length > 0)
            .length
    }

    async navigateToEdit(team: Branch): Promise<void> {
        await this.$router.push({
            name: 'company_settings_teams_edit',
            params: {
                teamId: team.id,
            },
        })
    }
}
